import { BAR, PIE, FUNNEL } from "src/components/Charts/types";
import { recalculateBarData } from "./bar";

const strategies = {
  [BAR]: recalculateBarData,
  [PIE]: recalculateBarData,
  [FUNNEL]: recalculateBarData,
};

/**
 * Resolve qual estratégia de recálculo de porcentagens deve ocorrer de acordo com o gráfico atualmente plotado no card
 * e a retorna.
 * @param {string} chartType Tipo do gráfico (bar | pie | x) 
 * @param {array} originalData Dados plotados no gráfico
 * @param {array} disabledLegends Legendas desabilitadas
 * @param {boolean} allowPercentRecalcs flag que indica se deve ocorrer recálculo
 * @returns 
 */
export const recalcResolver = function (
  chartType,
  originalData,
  disabledLegends = [],
  allowPercentRecalcs = false
) {
  let recalcStrategy;

  if ((recalcStrategy = strategies[chartType])) {
    return recalcStrategy.call(null, originalData, disabledLegends, allowPercentRecalcs);
  }

  return originalData;
};
